// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.admin.employee.detailed.response.AdminEmployeeExternalSystemsResponse */
/* istanbul ignore next */
@GandalfModel
export class AdminEmployeeExternalSystemsResponse extends GandalfModelBase {

	@GandalfConstantDecorator(constants.DirectAddressStatus)
	@GandalfProperty({ designType: constants.DirectAddressStatus })
	directAddressStatus!: constants.DirectAddressStatus | null;

	@GandalfProperty({ designType: String })
	directAddressUsername!: string | null;

	@GandalfProperty({ designType: Boolean })
	practiceRxntIsEnabled!: boolean | null;

	@GandalfProperty({ designType: Boolean })
	rxntIsActive!: boolean | null;

	@GandalfProperty({ designType: String })
	rxntPassword!: string | null;

	@GandalfProperty({ designType: String })
	rxntUsername!: string | null;

}
